import styles from "./Receipt.module.css";

interface ReceiptProps {
  text: string;
}

export function Receipt({ text }: ReceiptProps) {
  return (
    <div className={styles.receipt} role="status">
      <span className={styles.check} aria-hidden>
        ✓
      </span>
      <span className={styles.body}>{text}</span>
      <span className={styles.sweep} aria-hidden />
    </div>
  );
}
